module.exports = __webpack_public_path__ + "static/img/contact.752754f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/contact.png
// module id = YTI6
// module chunks = 1